// extracted by mini-css-extract-plugin
export default {"space":"Style_space__xstgP"};